// TODO: remove
export const getTruncatedText = (text: string, isExpanded: boolean, maxChars: number): string => {
  if (text.length > maxChars && !isExpanded) {
    return text.slice(0, maxChars)
  }
  return text
}
